import * as React from 'react';
import * as Yup from 'yup';

import { Formik, FormikActions, FormikProps } from 'formik';
import { processApiError, toFormGroupStyle } from 'common/utils/form';

import { Activity } from 'common/api/models/Activity';
import { ActivityApi } from 'common/api/resources/ActivityApi';
import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';
import { FormGroup } from 'reactstrap';
import { Analytics } from 'common/utils/Analytics';
import { FormInput } from 'common/components/form/FormInput';

interface ActivityFeedCeuFormProps {
  entityId: string;
  entityType: string;
  onCancel: () => void;
  onSave: () => void;
}

interface CeuFormValues {
  credits: number;
  description: string;
  note: string;
}

export class ActivityFeedCeuForm extends React.Component<ActivityFeedCeuFormProps> {
  validationSchema = Yup.object().shape({
    credits: Yup.number().required('Credits are required.'),
    description: Yup.string().required('Description is required.'),
    note: Yup.string(),
  });

  getInitialValues = () => {
    const values: CeuFormValues = { credits: 0, note: '', description: '' };
    return values;
  };

  handleSubmit = (values: CeuFormValues, actions: FormikActions<CeuFormValues>) => {
    ActivityApi.createActivity({
      entityId: this.props.entityId,
      entityType: this.props.entityType,
      type: Activity.Type.POINTS,
      units: values.credits,
      note: values.note,
      description: values.description,
    }).then(
      res => {
        Analytics.member.ceu();
        this.props.onSave();
        actions.setSubmitting(false);
        actions.resetForm();
      },
      err => {
        processApiError(err, actions);
      }
    );
  };

  render() {
    return (
      <div className="card card-responsive">
        <div className="card-block">
          <Formik
            initialValues={this.getInitialValues()}
            validationSchema={this.validationSchema}
            onSubmit={this.handleSubmit}
            render={(form: FormikProps<CeuFormValues>) => (
              <form onSubmit={form.handleSubmit}>
                <FormInput
                  label=""
                  id="credits"
                  name="credits"
                  style={{ width: '5rem' }}
                  type="number"
                  step="0.05"
                  autoFocus={true}
                />
                <FormGroup color={toFormGroupStyle('description', form)}>
                  <textarea
                    name="description"
                    className="form-control"
                    placeholder="Add a description that will be visible to the member."
                    rows={1}
                    onChange={form.handleChange}
                    value={form.values.description}
                  />
                  <FormErrorFeedback form={form} field="description" />
                </FormGroup>
                <FormGroup color={toFormGroupStyle('note', form)}>
                  <textarea
                    name="note"
                    className="form-control"
                    placeholder="Add an optional note. Notes are strictly internal to NKBA staff."
                    rows={2}
                    onChange={form.handleChange}
                    value={form.values.note}
                  />
                  <FormErrorFeedback form={form} field="note" />
                </FormGroup>
                <div className="row">
                  <div className="col">
                    <a className="btn btn-sm btn-secondary" onClick={this.props.onCancel}>
                      Cancel
                    </a>{' '}
                    <button className="btn btn-sm btn-primary">Save</button>
                  </div>
                </div>
              </form>
            )}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/activity/ActivityFeedCeuForm.tsx